import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'g-columnDropdown',
  templateUrl: './columnDropdown.component.html'
})
export class ColumnDropdownComponent implements OnInit {
  constructor() { }

  @Input() data: any[];
  @Input() isGrouped: boolean = false;
  @Input() isEditing: boolean = false;
  @Input() isDisabled: boolean = false;
  @Input() width: string = undefined;
  @Input() selectedItem: any;
  @Input() referenceObject: any;

  @Output() onItemChanged: EventEmitter<{ referenceObject: any, selectedItem: any }> = new EventEmitter();

  ngOnInit() {
  }

  selectedItemChanged() {
    this.onItemChanged.emit({
      referenceObject: this.referenceObject,
      selectedItem: this.selectedItem
    }
    )
  }
}
